"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNever = void 0;
function assertNever(x) {
    const err = `expected x to be never at compile time, but received "${x}"`;
    throw new Error(err);
}
exports.assertNever = assertNever;
//# sourceMappingURL=assertNever.js.map